export const SPECIAL_COMP_PREFILL = {
  PhyAttend: {
    LABEL: "Physical Attendance:",
    PARAGRAPH: "{companyNm} will be hosting the meeting in person and by electronic means. However, due to limited number of attendees allowed to physically attend, all registrants' request for physical attendance will be subject for approval",
    CHECKBOX: "I/we would want to attend the meeting in person.",
  },
  AgreeTerms: {
    CONTENT: "I/we agree to the above",
  }
}

// FIELDS root node
export const PDICS = {
  layout: {
    seq: 1
  },
  metadata: {
    type: "PDICS",
    fieldName: "shareholder",
    label: "Shareholder",
    radio: {
      fieldName: "holderType",
      required: true,
      label: "Individual or Corporate Shareholder",
      options: [
        { label: "Individual Shareholder", value: "I" },
        { label: "Corporate Shareholder", value: "C" }
      ]
    },
    text: {
      ind: { fieldName: "holderNm", label: "Full Name", required: true },
      corp: {
        company: { fieldName: "companyNm", label: "Name of Company", required: true },
        companyRep: { fieldName: "repNm", label: "Name of Corporate Representative", required: true }
      }
    }
  }
}

export const PhyAttend = [
  {
    layout: {
      seq: 1
    },
    metadata: {
      type: "STATIC",
      content: "",
      sharedValuesKeyMapping: {
        companyNm: "companyNm",
        conveneTC: "conveneTC",
        convenePrivacy: "convenePrivacy"
      }
    }
  },
  {
    layout: {
      seq: 2
    },
    metadata: {
      type: "CHECKBOX",
      fieldName: "physicalAttendRequest",
      content: "",
      sharedValuesKeyMapping: {
        companyNm: "companyNm"
      }
    }
  }
]

export const AgreeTerms = {
  layout: {
    seq: 1
  },
  metadata: {
    type: "CHECKBOX",
    fieldName: "agreeToCompany",
    content: "",
    required: true
  }
}

// AREAS root node
export const PFSI = {
  layout: {
    seq: 1
  },
  metadata: {
    type: "PFSI",
    fieldName: "shareholderInfo"
  }
}

export const PFCP = {
  layout: {
    seq: 1
  },
  metadata: {
    type: "PFCP",
    fieldName: "proxyEntries"
  }
}

export const PFRP = {
  layout: {
    seq: 1
  },
  metadata: {
    type: "PFRP",
    fieldName: "proxyEntries",
    defaultChairmanAsIndVal: 1
  }
}

export const PFTS = {
  layout: {
    seq: 1
  },
  metadata: {
    type: "PFTS",
    fieldName: "totalShares"
  }
}

export const PFHT = {
  layout: {
    seq: 1
  },
  metadata: {
    type: "PFHT",
    fieldName: "totalShares"
  }
}

export const PFDS = {
  layout: {
    seq: 1
  },
  metadata: {
    type: "PFDS"
  }
}

export const PFRT = {
  layout: {
    seq: 1
  },
  metadata: {
    type: "PFRT",
    fieldName: "votes"
  }
}

export const VFRT = {
  layout: {
    seq: 1
  },
  metadata: {
    type: "VFRT",
    fieldName: "votes",
    notStartedTempl: "<p>Voting Has Not Started.</p>",
    endedTempl: "<p>Voting Has Ended.</p>",
    noRightsTempl: "<p>You have no voting rights.</p>"
  }
}

export const PRCT = {
  layout: {
    seq: 1
  },
  metadata: {
    type: "PRCT",
    titleTempl: '<font size=20px><strong>${TITLE}</strong></font><br>',
    statTempl: '<font size=20px>The number of votes "${CHOICE_TITLE}" is <strong>${WEIGHTED_SHARE}</strong>(${WEIGHTED_PERC}%)</font><br>',
    decisionTempl: '<br><font size=20px>Based on the result, ${DECLARE_STATEMENT} ${TITLE} ${DECISION}.</p>'
  }
}